const TeachersTableColumns = [
    { id: 'employee_name', labelAr: 'اسم الموظف', labelEn: 'Employee' },
    { id: 'school_name', labelAr: 'المدرسة', labelEn: 'School', width: 140 },
    { id: 'phone', labelAr: 'الهاتف', labelEn: 'Phone', width: 120 },
    { id: 'memorized_parts_count', labelAr: 'الأجزاء المحفوظة', labelEn: 'Parts', width: 80 },
    { id: 'has_ijazah', labelAr: 'إجازة', labelEn: 'Ijazah', width: 80 },
    { id: 'is_active', labelAr: 'الحالة', labelEn: 'Status', width: 90 },
];

export default TeachersTableColumns;
